<template>

      <!-- Begin page -->
      <div id="wrapper">

            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->


            <!-- ========== Left Sidebar Start ========== -->

            <!-- Left Sidebar End -->
            <left></left>


            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">

                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">我的主页</h4>

                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">CPWM</a></li>
                                                      <li class="breadcrumb-item active">我的主页</li>
                                                </ol>

                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->


                              <div class="row">
                                    <div class="col-md-6" :class="isismobile?'w100':'w65'" style="flex:auto;">
                                          <div class="card-box">


                                                <ul class="nav nav-tabs tabs-bordered">
                                                      <li class="nav-item">
                                                            <a href="#home" data-toggle="tab" aria-expanded="true"
                                                               class="nav-link " :class="show==undefined?'active':''">
                                                                  个人资料
                                                            </a>
                                                      </li>
                                                      <li class="nav-item">
                                                            <a href="#messages" data-toggle="tab" aria-expanded="false"
                                                               class="nav-link " :class="show==2?'active':''">
                                                                  消息
                                                                  <span class="badge badge-danger badge-pill noti-icon-badge"
                                                                        v-if="num!=0">{{num}}</span>
                                                            </a>
                                                      </li>
                                                      <li class="nav-item">
                                                            <a href="#authentication" data-toggle="tab"
                                                               aria-expanded="true" class="nav-link "
                                                               :class="show==3?'active':''">
                                                                  证书信息
                                                            </a>
                                                      </li>
                                                </ul>
                                                <div class="tab-content">
                                                      <div class="tab-pane fade " id="home"
                                                           :class="show==undefined?'show active':''">
                                                            <!--start-->


                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*姓（中文）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="surname"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*名（中文）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="name"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*姓（拼音）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="surname_en"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*名（拼音）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="name_en"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*性别</p>
                                                                  <input type="text" name="country"
                                                                         v-model="sex"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">手机号</p>
                                                                  <input type="text" name="country"
                                                                         v-model="tel"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*邮箱</p>
                                                                  <input type="text" name="country"
                                                                         v-model="email"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">工作单位（总公司）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="Headquarters"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">工作单位（分公司）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="BranchOffice"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">工作部门</p>
                                                                  <input type="text" name="country"
                                                                         v-model="WorkDepartment"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">工作职务</p>
                                                                  <input type="text" name="country"
                                                                         v-model="Jobduties"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself2">
                                                                  <p class="mb-1 mt-4 font-weight-bold">联系地址</p>
                                                                  <input type="text" name="country"
                                                                         v-model="address"
                                                                         class="form-control">
                                                            </div>
                                                            <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                                  <button type="submit" style="margin: 0 auto;"
                                                                          class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                                          v-on:click="edit">确认
                                                                  </button>
                                                            </div>
                                                            <div style="clear: both"></div>


                                                            <!--over-->
                                                      </div>
                                                      <div class="tab-pane fade" id="messages"
                                                           :class="show==2?'show active':''">
                                                            <div v-for=" item,index in msglist" class="msglist">
                                                                  <li v-on:click="showmsgfun(item.id)">
                                                                        <i class="mdi mdi-email-outline"
                                                                           v-if="item.readnow==0"></i>
                                                                        <i class="mdi mdi-email-open-outline"
                                                                           v-if="item.readnow==1"></i>
                                                                    <font v-html="item.title"></font>


                                                                  </li>
                                                                  <li class="msglistright">{{item.created_at}}</li>
                                                            </div>
                                                            <div style="clear: both;width:1px;height:1px;"></div>
                                                      </div>
                                                      <div class="tab-pane fade" id="authentication"
                                                           :class="show==3?'show active':''">
                                                            <table class="table">
                                                                  <thead>
                                                                  <tr>
                                                                        <th>认证类型</th>
                                                                        <th>证书有效期</th>
                                                                        <th>证书状态</th>
                                                                        <th>证书编号</th>
                                                                  </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                  <tr v-for="item,index in authenticationlist" v-if="item.timestart">
                                                                        <th scope="row">CPWM</th>
                                                                        <td>
                                                                              {{item.timestart.substring(0,10)}}->{{item.timeover.substring(0,10)}}
                                                                        </td>
                                                                        <td>
                                                                              <img src="images/gou.jpeg" width="20px"
                                                                                   height="20px"
                                                                                   v-if="item.zustatus==0">
                                                                              <img src="images/cha.png" width="20px"
                                                                                   height="20px"
                                                                                   v-if="item.zustatus==1">
                                                                        </td>
                                                                        <td>{{item.num}}</td>
                                                                  </tr>
                                                                  <tr v-for="item,index in authenticationlist2" v-if="item.timestart">
                                                                        <th scope="row">CPWM1</th>
                                                                        <td>
                                                                              {{item.timestart.substring(0,10)}}->{{item.timeover.substring(0,10)}}
                                                                        </td>
                                                                        <td>
                                                                              <img src="images/gou.jpeg" width="20px"
                                                                                   height="20px"
                                                                                   v-if="item.zustatus==0">
                                                                              <img src="images/cha.png" width="20px"
                                                                                   height="20px"
                                                                                   v-if="item.zustatus==1">
                                                                        </td>
                                                                        <td>{{item.num}}</td>
                                                                  </tr>
                                                                  </tbody>
                                                            </table>
                                                      </div>

                                                </div>
                                          </div>
                                    </div> <!-- end col -->

                                    <div class="col-md-6" :class="isismobile?'w100':'w35'"  style="flex:auto;">
                                          <div class="card-box">
                                                <h4 class="header-title m-t-0 m-b-30">考试与认证资讯</h4>


                                                <div class="tab-content" style="padding-top:0px;">
                                                      <div class="zx">
                                                            <div v-for=" item,index in zxlist">
                                                                  <li><a :href="item.url" target="_blank"
                                                                         style="color:#67757c;line-height: 23px;"
                                                                         v-html="item.title"></a>
                                                                  </li>
                                                                  <li style="text-align: right;color:#67757c;line-height: 23px;border-bottom: 1px dashed #a8a097;font-size:11px;">
                                                                        {{item.created_at.substring(0,10)}}
                                                                  </li>
                                                            </div>


                                                      </div>
                                                      <div style="clear: both"></div>

                                                </div>
                                          </div>
                                    </div> <!-- end col -->
                              </div>
                              <!-- end row -->


                        </div> <!-- container -->

                  </div> <!-- content -->

                  <!--footer-->

                  <!--中间弹窗-->
                  <div class="tanchuang" v-if="showmsg" :class="isismobile?'tanchuang_shouji':''">
                        <h2 v-html="title"></h2>
                        <ul>

                              <li style="text-align: left" v-html="content">

                              </li>
                              <li style="margin-top:40px;">
                                    <button type="submit" style="margin: 0 auto;"
                                            class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                            v-on:click="closemsg">确认
                                    </button>
                              </li>
                        </ul>
                  </div>
            </div>


            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->


      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';

      export default {
            name: 'main',
            components: {topbar, left},
            data() {
                  return {
                        tel: this.tel,
                        email: this.email,
                        lisname: this.lisname,

                        surname: this.surname,
                        name: this.name,
                        surname_en: this.surname_en,
                        name_en: this.name_en,
                        sex: this.sex,
                        Headquarters: this.Headquarters,
                        BranchOffice: this.BranchOffice,
                        WorkDepartment: this.WorkDepartment,
                        Jobduties: this.Jobduties,
                        address: this.address,
                        //other

                        msglist: this.msglist,
                        showmsg: false,
                        title: this.title,
                        content: this.content,

                        show: this.$route.query.show,
                        num: this.num,
                        zxlist: this.zxlist,
                        authenticationlist: this.authenticationlist,
                        authenticationlist2:this.authenticationlist2,

                        isismobile:this.ismobile(),
                  }
            },
            mounted() {
                  this.showmember();
                  this.m_list();
                  this.msg();
                  this.zx_list();
                  this.show_status();
                  this.authentication_list();
                  this.authentication_list2();
                  document.getElementsByTagName("body")[0].className = "";


            },
            methods: {
                  msg: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/msg_num',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.num = response.data;

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  showmember: function () {
                        //console.log(this.identity);
                        let data = {
                              tel: this.tel
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.tel = response.data.user.tel;
                              this.email = response.data.user.email;
                              this.lisname = response.data.user.name;

                              this.surname = response.data.information.surname;
                              this.name = response.data.information.name;
                              this.surname_en = response.data.information.surname_en;
                              this.name_en = response.data.information.name_en;
                              this.sex = response.data.information.sex;
                              this.Headquarters = response.data.information.Headquarters;
                              this.BranchOffice = response.data.information.BranchOffice;
                              this.WorkDepartment = response.data.information.WorkDepartment;
                              this.Jobduties = response.data.information.Jobduties;
                              this.address = response.data.information.address;


                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  edit: function () {
                        let data = {
                              tel: this.tel,

                              surname: this.surname,
                              name: this.name,
                              surname_en: this.surname_en,
                              name_en: this.name_en,
                              sex: this.sex,
                              Headquarters: this.Headquarters,
                              BranchOffice: this.BranchOffice,
                              WorkDepartment: this.WorkDepartment,
                              Jobduties: this.Jobduties,
                              address: this.address,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/member_edit',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if (response.data.code == 0) {
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'success',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              } else {
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function OnError() {

                        })
                  },
                  m_list: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/msg_list',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.msglist = response.data;


                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  zx_list: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/zx',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.zxlist = response.data;


                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  goto: function (url) {
                        //this.$router.push({path:url});
                        window.location.href = "/member2/#" + url;
                  },
                  showmsgfun: function (id) {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/msg_show?id=' + id,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.title = response.data.title;
                              this.content = response.data.content;
                              this.showmsg = true;
                              this.m_list();
                              this.msg();


                        }.bind(this)).catch(function OnError() {

                        })
                  },
                  closemsg: function () {
                        this.showmsg = false;
                  },
                  show_status: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication_status',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if (response.data.code == 2) {
                                    if (response.data.status == 4) {
                                          //证书已经邮寄
                                          window.location.href = '#/main?show=3';
                                    }
                              }
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  authentication_list: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/authentication_list',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.authenticationlist = response.data;
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  authentication_list2: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/authentication_list2',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.authenticationlist2 = response.data;
                        }.bind(this)).catch(function OnError() {

                        })

                  },

                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }

      .zx li {
            width: 100%;
            float: left
      }

      .msglist li {
            width: 50%;
            float: left;
            line-height: 4rem;
      }

      .msglist {
            width: 100%;
            float: left;
            border-bottom: 1px dashed #cccccc
      }

      .msglistright {
            text-align: right;
      }

      .inputself {
            width: 47.5%;
            margin-right: 2.5%;
            float: left
      }

      .inputself2 {
            width: 47.5%;
            margin-left: 2.5%;
            float: right
      }

      .tanchuang {
            border: 1px solid #0000ff;
            top: 30%;
            position: fixed;
            width: 30%;
            left: 35%;
            background-color: #ffffff;
            padding: 1%;
            z-index: 100;
            border-radius: 20px;

      }

      .tanchuang h2 {
            font-size: 18px;
            border-bottom: 1px dashed #8c8c8c;
            line-height: 42px;
            font-weight: bold;
      }
      .tanchuangh2 {
        font-size: 18px;
        border-bottom: 1px dashed #8c8c8c;
        line-height: 42px;
        font-weight: bold;
      }
      .tanchuang ul {
            margin: 20px;
      }

      .tanchuang li {
            line-height: 32px;
            text-align: center;
            width: 100%;
            float: left;
      }

      .tanchuang li p {
            line-height: 40px;
      }

      .tanchuang .pass {
            height: 22px;
      }

      .tanchuang .buttonclass {
            margin: 0 30px;
            padding: 0 10px;
      }
      .w35{
            width: 35% !important;
            max-width: 35% !important;
      }
      .w65{
            width: 65% !important;
            max-width: 65% !important;
      }
      .w100{
            width: 100% !important;
            max-width: 100% !important;
      }
      .tanchuang_shouji{
            width: 60% !important;
            left: 18% !important;
      }
</style>



// WEBPACK FOOTER //
// src/components/main.vue